__turbopack_context__.v({
  "avatar": "_8IclTG_avatar",
  "avatars": "_8IclTG_avatars",
  "avatarsContainer": "_8IclTG_avatarsContainer",
  "description": "_8IclTG_description",
  "desktop": "_8IclTG_desktop",
  "footer": "_8IclTG_footer",
  "footerCount": "_8IclTG_footerCount",
  "footerRow": "_8IclTG_footerRow",
  "footerText": "_8IclTG_footerText",
  "headerSection": "_8IclTG_headerSection",
  "mobile": "_8IclTG_mobile",
  "mobileCount": "_8IclTG_mobileCount",
  "mobileCountText": "_8IclTG_mobileCountText",
  "mobileDescription": "_8IclTG_mobileDescription",
  "mobileFooter": "_8IclTG_mobileFooter",
  "mobileHeaderSection": "_8IclTG_mobileHeaderSection",
  "mobileProjectsSection": "_8IclTG_mobileProjectsSection",
  "mobileTeamsSection": "_8IclTG_mobileTeamsSection",
  "mobileTitle": "_8IclTG_mobileTitle",
  "title": "_8IclTG_title",
});
